import type { Row } from "./types";

/**
 * KANBAN DAS ATIVIDADES — as colunas do quadro e EM QUAL delas cada OS cai.
 *
 * As 4 colunas seguem o kanban do OMIE (Ordem de Serviço → Em execução →
 * Retrabalho → Faturar). Arrastar o cartão grava a coluna só NESTE sistema
 * (PUT /api/atividades/:id/kanban, ver server/kanban.ts) — o OMIE nunca é
 * alterado daqui.
 *
 * As chaves precisam bater com o conjunto COLUNAS de server/kanban.ts.
 */
export type ColunaKanban = "os" | "execucao" | "retrabalho" | "faturar";

export const COLUNAS_KANBAN: { key: ColunaKanban; label: string }[] = [
  { key: "os", label: "Ordem de Serviço" },
  { key: "execucao", label: "Em execução" },
  { key: "retrabalho", label: "Retrabalho" },
  { key: "faturar", label: "Faturar" },
];

export function ehColunaKanban(v: unknown): v is ColunaKanban {
  return typeof v === "string" && COLUNAS_KANBAN.some((c) => c.key === v);
}

/**
 * A coluna do cartão. É a ÚNICA regra do quadro — a tela inteira passa por aqui.
 *
 * 1. Se alguém arrastou o cartão (`kanban_coluna`) e a etapa do OMIE ainda é a
 *    mesma da hora do arraste (`kanban_etapa_ref`), vale o arraste.
 * 2. Senão, a coluna sai da etapa do OMIE (20 = Em execução; 30 Executada e
 *    50 Faturar = Faturar) ou, para atividade manual, do status daqui.
 *    Todo o resto fica em "Ordem de Serviço".
 *
 * Por quê: o OMIE continua mandando a etapa real a cada 15 min. O arraste
 * "gruda" até o OMIE mover a OS; quando ele move, o cartão passa a seguir o
 * OMIE de novo — sem isso, o quadro daqui e o do OMIE iriam se afastando para
 * sempre, ou o arraste seria desfeito a cada sincronização.
 */
export function colunaDaAtividade(row: Row): ColunaKanban {
  const etapa = String(row.etapa_omie ?? "");
  if (ehColunaKanban(row.kanban_coluna) && String(row.kanban_etapa_ref ?? "") === etapa) {
    return row.kanban_coluna;
  }
  const status = String(row.status ?? "");
  if (etapa === "20" || status === "Em andamento") return "execucao";
  if (etapa === "30" || etapa === "50" || status === "Executada" || status === "Concluída") {
    return "faturar";
  }
  return "os";
}
